import { makeVar } from '@apollo/client'

import { PageType } from './layout/PageWrapper'

/**
 * To globally keep track of the page type, mainly for GA4 events. I wouldn't rely on this if
 * it is important.
 */
export const pageTypeVar = makeVar<PageType>('N/A')
